<div class="typeahead-wrap relative" [class.map-mode]="showMap()">
  <mobi-ui-typeahead-major
    class="search"
    [matchOptions]="false"
    [autocomplete]="'off'"
    [maxNumberOfOptions]="10"
    [ignoreCase]="true"
    area-owns="something"
    [aria-label]="
      breakpoint.xsMax() || !showMap()
        ? ('gasearch_input_mobile'
          | texts
            : {
                context: 'frontend',
                default: 'PLZ / Ort',
              })
        : ('gasearch_input'
          | texts
            : {
                context: 'frontend',
                default: 'Bitte geben Sie Ihre Postleitzahl oder Ihren Wohnort an',
              })
    "
    [placeholder]="
      breakpoint.xsMax() || showMap()
        ? ('gasearch_input_mobile'
          | texts
            : {
                context: 'frontend',
                default: 'PLZ / Ort',
              })
        : ('gasearch_input'
          | texts
            : {
                context: 'frontend',
                default: 'Bitte geben Sie Ihre Postleitzahl oder Ihren Wohnort an',
              })
    "
    [value]="searchTerm()"
    (searchTermChange)="onSearchTermChange($event)"
    (valueChange)="onValueChanges($event)"
  >
    @for (match of searchMatches(); track match.label) {
      <mobi-ui-typeahead-option-major [value]="match.label">
        {{ match.label }}
      </mobi-ui-typeahead-option-major>
    }
  </mobi-ui-typeahead-major>
  @if (searchTerm() !== '' && breakpoint.smAndLarger()) {
    <button
      class="search-icon absolute top-[5px] right-0 my-0 mr-[10px] z-[4] pointer-events-auto"
      (click)="onValueChanges('')"
    >
      <mobi-ui-icon-major name="the_x" class="text-black" />
    </button>
  }
  @if (!searchTerm() && breakpoint.smAndLarger()) {
    <span
      class="search-icon absolute top-[5px] right-0 my-0 mr-[10px] z-[4] pointer-events-auto"
    >
      <mobi-ui-icon-major name="search" class="text-black" />
    </span>
  }
</div>
